/**
 * @desc 通过参数获取sku信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.SkuResponseDto>>;
export function request(
  body: defs.basics.ProductSkuRequestDtoRPC,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/sku/byRequestDto`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
